import React from 'react';
import { useTheme } from '../context/ThemeContext';

const DarkModeToggle: React.FC<{ inline?: boolean }> = ({ inline = false }) => {
  const { isDarkMode, toggleDarkMode, colors } = useTheme();

  return (
    <button
      onClick={toggleDarkMode}
      className={`${inline ? 'relative' : 'fixed top-6 right-6 z-40'} w-10 h-10 rounded-full border transition-all duration-300`}
      style={{ 
        backgroundColor: colors.surface, 
        borderColor: colors.border,
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)'
      }}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <div className="flex items-center justify-center">
        {isDarkMode ? (
          <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            style={{ color: colors.textPrimary }}
          >
            <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="currentColor" strokeWidth="2"/>
          </svg>
        ) : (
          <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            style={{ color: colors.textPrimary }}
          >
            <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" stroke="currentColor" strokeWidth="2"/>
          </svg>
        )}
      </div>
    </button>
  );
};

export default DarkModeToggle;
